var moduleMap = {
	"./Component": () => {
		return __webpack_require__.e(/* __federation_expose_Component */ 165).then(() => (() => ((__webpack_require__(6728)))));
	},
	"./Routes": () => {
		return __webpack_require__.e(/* __federation_expose_Routes */ 286).then(() => (() => ((__webpack_require__(9691)))));
	},
	"./app-component": () => {
		return __webpack_require__.e(/* __federation_expose_app_component */ 705).then(() => (() => ((__webpack_require__(8911)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});